import { render } from "./RenameSubscribeDialog.vue?vue&type=template&id=8fa07a92"
import script from "./RenameSubscribeDialog.vue?vue&type=script&lang=ts"
export * from "./RenameSubscribeDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script